import React, { useState, useEffect } from 'react';
import styles from './review.module.scss';
import { Col, Row } from 'react-bootstrap';
import { Document, Page, pdfjs } from 'react-pdf';
import { sendOfferToCandidate, getPresignedUrlToUploadOfferLetter, uploadOfferLetterToS3 } from '../../../../../services/util/offerHandling';
import { CustomButton } from '../../../../shared/customButton';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Review = (props) => {
    const options = {
        cMapUrl: 'cmaps/',
        cMapPacked: true,
    };

    const [documents, setDocuments] = useState([]);
    const [isUploadLoading, setUploadLoading] = useState(false);

    useEffect(() => {
        setDocuments(
            props.values.documents.map(doc => ({
                name: doc.name,
                type: doc.type,
                file: doc.type === 10 ? doc.file : null,
                link: doc.type === 20 ? doc.link : null,
                is_sign_required: doc.is_sign_required,
            }))
        );
    }, [props.values.documents]);

    const submitDetails = async () => {
        setUploadLoading(true);
        try {
            // Step 1: Handle file uploads
            const updatedDocuments = [...documents]; // Local copy of documents
            const uploadPromises = documents.map(async (doc, index) => {
                if (doc.type === 10 && doc.file) {
                    let fileType = (doc.file.type.split('/')[1] || '').toLowerCase();
                    const presignedURL = await getPresignedUrlToUploadOfferLetter(props.offerSessionDetails.offerSessionId, index, fileType);
                    
                    if (presignedURL.success) {
                        await uploadOfferLetterToS3(presignedURL.data.presigned_url, doc.file);
                        // Update local copy of documents
                        updatedDocuments[index].isUploaded = true;
                        updatedDocuments[index].internalFileUploadedName = presignedURL.data.offer_document_name; // Save the URL for later use
                    } else {
                        throw new Error('Failed to get presigned URL');
                    }
                }
            });
    
            // Wait for all uploads to complete
            await Promise.all(uploadPromises);

            // Step 2: Prepare data for sending
            let data = {
                offer_session_id: props.offerSessionDetails.offerSessionId,
                documents: updatedDocuments // Use the updated local copy
            };
    
            // Step 3: Send the offer letter
            const sendOfferLetterRespond = await sendOfferToCandidate(data);
    
            if (sendOfferLetterRespond.success) {
                setUploadLoading(false);
                props.handleClose();
                props.refreshData();
            } else {
                throw new Error('Failed to send offer letter to candidate');
            }
        } catch (error) {
            setUploadLoading(false);
            throw new Error('Failed to send offer letter to candidate');
        }
    };
    
    return (
        <div>
            <Col>
                {documents.map((doc, index) => (
                    <Row key={index} className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>
                                {doc.name}&nbsp;
                                <span className={styles.docTypeview}>
                                    {doc.type === 20 ? '(External Document Link) :' : '(Uploaded File) :'}
                                </span>
                            </span>
                            {doc.type === 10 && doc.file ? (
                                <div className={styles.imageContainer}>
                                    <Document file={doc.file} options={options}>
                                        <Page pageNumber={1} scale={0.24} />
                                    </Document>
                                </div>
                            ) : doc.type === 20 && doc.link ? (
                                <p className={styles.rowLink}>{doc.link}</p>
                            ) : null}
                        </Col>
                    </Row>
                ))}
            </Col>
            <div className='d-flex flex-row-reverse'>
                <div className={styles.navigateBtnCol}>
                    <CustomButton
                        buttonType="submit"
                        label="Submit"
                        type="primaryBtn"
                        backicon={isUploadLoading ? (<i className="fas fa-circle-notch fa-spin"></i>) : ''}
                        disabled={isUploadLoading}
                        handleClick={submitDetails}
                    />
                     <CustomButton
                        buttonType="submit"
                        label="Back"
                        type="defaultBtn"
                        handleClick={() => props.previousPage(1)}
                        disabled={isUploadLoading}
                    />
                </div>
            </div>
           
        </div>
    );
};

export default Review;
